<template>
    <div class="footer-text">
        <div :class="[fluid ? 'container-fluid' : 'container', 'mt-4 mb-4']" v-html="footerText"></div>
    </div>
</template>

<script>
export default {
    name: "footer-text",
    props: ['fluid','footerText']
}
</script>

<style scoped lang="scss">

.footer-text {
    font-size: 1rem;
    background: white;
    border-top: 1px solid rgba(1,1,1, 0.1);
    margin-top: 2rem;

    p {
        font-size: 14px;
        line-height: 24px;
        margin: 1em 0;
        padding: initial;
        white-space: initial;
    }
}

</style>
